import { render, staticRenderFns } from "./health-temperature.input.vue?vue&type=template&id=34b9d060&"
import script from "./health-temperature.input.vue?vue&type=script&lang=ts&"
export * from "./health-temperature.input.vue?vue&type=script&lang=ts&"
import style0 from "./health-temperature.input.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports